module.exports = __webpack_public_path__ + "static/media/img_login_background.b6acc1d3.webp";